export default ({ title_name, title, current }) =>
  // display_name
  //   ? display_name.split(",")[0] + ` ($${current})`
  //   : `${title.split(",")[0]} at ${company}`;
  current ? title_name || title + ` ($${current})` : title_name || title;



// WEBPACK FOOTER //
// ./src/components/common/candidate/Name.js